import { CerFormAdapter } from "@cer/cer-form/cer-form-adapter";
import { CerFormView } from "@cer/cer-form/cer-form-view";

export class ContractTypeForm extends CerFormAdapter {

  override view(): CerFormView {
    return new CerFormView({
      viewMetadata: {
        name: 'aftale-typer', dataApiName: 'ContractType', text: 'Aftaletyper', textSingular: 'Aftaletype',
        primaryKey: 'num', baseFields: ['id', 'num', 'name', 'sorting', 'history']
      },
      fieldMetadata: [
        { name: 'royalty', text: 'Royaltyafregning?', tooltipText: 'Omfattes af royaltyafregning?', format: 'CheckBox', defaultValue: false },
        { name: 'author', text: 'Forfatterafregning?', tooltipText: 'Omfattes af forfatterafregning?', format: 'CheckBox', defaultValue: false },
        { name: 'budget', text: 'Forfatterafregning, budget?', tooltipText: 'Anvendes budget i forfatterafregning?', format: 'CheckBox', defaultValue: false },
        { name: 'legacyId', text: 'Opr. Id', tooltipText: 'Id fra oprindelig database', visible: false, format: 'Integer' }
      ]
    });
  }
}
